'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoLaw = function GoLaw(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.1 7.5c1.3 0 2.4-1.1 2.4-2.4 0-1.5-1.1-2.6-2.6-2.6-1.3 0-2.4 1.1-2.4 2.4 0 1.5 1.1 2.6 2.6 2.6z m18.1 15h-0.7l-5-9.6c0.7-0.1 1.4-0.4 2.1-0.6 0.9-0.5 1.1-1.7 0.4-2.5l0 0c-0.5-0.4-1.1-0.6-1.7-0.3-0.6 0.2-1.3 0.5-2.1 0.5-2.2 0-3.2-2.5-11.2-2.5s-9 2.5-11.2 2.5c-0.8 0-1.5-0.2-2.1-0.5-0.6-0.2-1.2-0.1-1.7 0.3l0 0c-0.7 0.8-0.5 2 0.4 2.5 0.7 0.3 1.4 0.5 2.1 0.6l-5 9.6h-0.7c-0.3 0-0.5 0.3-0.5 0.6 0.4 2.5 3.6 4.4 7.4 4.4s7.1-1.9 7.5-4.4c0-0.3-0.2-0.6-0.5-0.6h-0.7l-5-9.6c3.3-0.2 5-1.9 7.5-1.9v19c-1.4 0-2.5 1.1-2.5 2.5h-2.8c-1.1 0-2.2 1.1-2.2 2.5h20c0-1.4-1.1-2.5-2.8-2.5h-2.2c0-1.4-1.1-2.5-2.5-2.5v-19c2.5 0 4.2 1.7 7.5 1.9l-5 9.6h-0.7c-0.3 0-0.5 0.3-0.5 0.6 0.4 2.5 3.6 4.4 7.4 4.4s7.1-1.9 7.5-4.4c0-0.3-0.2-0.6-0.5-0.6z m-25.7 0h-7.5l3.8-7 3.7 7z m15 0l3.8-7 3.7 7h-7.5z' })
        )
    );
};

exports.default = GoLaw;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/law.js
// module id = 1929
// module chunks = 0